import { Icon, Row, Typography } from "@visa/vds"
import { ALERT_ICONS, EXPIRATION_ALERT } from "_constants/DashboardConstants";
import React, { useState } from "react"

const ProductCertificationFootnotes = (props) => {

    let [toggle, setToggle] = useState(false)
    let { expirationDays } = props
    return (
        <>
            <a className="cursor-pointer text-decoration-none font-size-16px padding-bottom-5px" onClick={() => setToggle(!toggle)} >
                <span className="padding-left-2px">Footnotes</span>
            </a >
            {toggle &&
                <>
                    <Row className="font-size-12px">
                        {ALERT_ICONS[EXPIRATION_ALERT.BLACK]} {`<= ${expirationDays[EXPIRATION_ALERT.BLACK]} days from expiration` + "\u00A0".repeat(5)}
                        {ALERT_ICONS[EXPIRATION_ALERT.YELLOW]} {`<= ${expirationDays[EXPIRATION_ALERT.YELLOW]} days from expiration` + "\u00A0".repeat(5)}
                        {ALERT_ICONS[EXPIRATION_ALERT.RED]} {`<= ${expirationDays[EXPIRATION_ALERT.RED]} days from expiration or expired`}
                    </Row>
                    <Row className="font-size-12px" style={{ paddingBottom: "15px" }}>
                        {"Click the" + "\u00A0".repeat(5)}
                        {ALERT_ICONS[EXPIRATION_ALERT.BLACK]}
                        {"," + "\u00A0".repeat(1)}
                        {ALERT_ICONS[EXPIRATION_ALERT.YELLOW]}
                        {"," + "\u00A0".repeat(1)}
                        {ALERT_ICONS[EXPIRATION_ALERT.RED]}
                        {"or" + "\u00A0".repeat(3)}
                        {ALERT_ICONS[EXPIRATION_ALERT.BLUE]}
                        {"to hide or show the alert icon"}
                    </Row >
                </>
            }
        </>
    )
}

export default ProductCertificationFootnotes